import { render, staticRenderFns } from "./header_menu_phone.vue?vue&type=template&id=32e8b7bc&scoped=true"
import script from "./header_menu_phone.vue?vue&type=script&lang=js"
export * from "./header_menu_phone.vue?vue&type=script&lang=js"
import style0 from "./header_menu_phone.vue?vue&type=style&index=0&id=32e8b7bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e8b7bc",
  null
  
)

export default component.exports